import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { useQuery } from '@tanstack/react-query';
import type { ReactElement } from 'react';

import { currentUserQuery } from '../../../lib/auth';
import { EmailCard } from '../components/EmailCard';
import { PasswordCard } from '../components/PasswordCard';
import { PersonalDetailsCard } from '../components/PersonalDetailsCard';
import { SettingsQueryGate } from '../components/SettingsQueryGate';

export function AccountSettingsPage(): ReactElement {
    const query = useQuery(currentUserQuery);

    return (
        <SettingsQueryGate
            query={query}
            loading={
                <Stack spacing={{ xs: 2, md: 3 }} aria-busy>
                    <Skeleton variant="rounded" height={140} />
                    <Skeleton variant="rounded" height={220} />
                    <Skeleton variant="rounded" height={300} />
                </Stack>
            }>
            {(user) => (
                <Stack spacing={{ xs: 2, md: 3 }}>
                    <PersonalDetailsCard user={user} />
                    <EmailCard user={user} />
                    <PasswordCard user={user} />
                </Stack>
            )}
        </SettingsQueryGate>
    );
}
